import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useTimesheetInfo } from '../../Hooks/Features/employeeDashboard/useTimesheetInfo';
import { SkeletonContainer } from '../Loader/Loader';

const TimesheetInfo = () => {
    const { options, loader } = useTimesheetInfo();

    return (
        <div title='Timesheet Info of current month' style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            {loader ? (
                <SkeletonContainer />
            ) : (
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                    containerProps={{
                        style: {
                            height: '100%',
                            width: '100%'
                        }
                    }}
                />
            )}
        </div>
    );
};

export default TimesheetInfo;
